module.exports = __webpack_public_path__ + "static/agency-preview-d70a3d783059dfc9b0a5724f555fb0a1.jpg";